import { ConfigureUpsellGroupFormState } from '../types'

/** How many upsell items the customer picked, over all upsell products */
export default function getSelectedUpsellCount(
  selectedUpsellGroups: ConfigureUpsellGroupFormState[],
) {
  return selectedUpsellGroups.reduce(
    (count, upsell) => count + upsell.selectedCount,
    0,
  )
}
